import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    padding: theme.spacing(4),
    paddingTop: theme.spacing(8),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(4),
      paddingBottom: 100,
    },
  },
  content: {
    display: "flex",
    gap: theme.spacing(2),
    alignItems: "center",
  },
  backButton: {
    position: "absolute",
    top: theme.spacing(2),
    left: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      position: "static",
      top: "auto",
      left: "auto",
      alignSelf: "flex-start",
    },
  },
  title: {
    fontSize: "2rem",
    color: theme.palette.primary.main,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    textAlign: "center",
    maxWidth: 605,
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.down("xl")]: {
      fontSize: "1.5rem",
    },
  },
  adPillarRight: {
    display: "none",
    [theme.breakpoints.up("xl")]: {
      height: 600,
    },
    [theme.breakpoints.up("lg")]: {
      display: "block",
      width: 160,
      height: 400,
    },
  },
  contentAd: {
    marginBottom: theme.spacing(4),
  },
  exploreRelated: {
    width: "100%",
  },
  notFoundContent: {
    marginTop: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  notFoundTitle: {
    fontSize: "2rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "1.25rem",
    },
  },
  notFoundText: {
    fontSize: "1rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.88rem",
    },
  },
  notFoundExploreRelated: {
    width: "100%",
    margin: theme.spacing(4),
  },
}));
